import {
  Sparkles, Mail, ShieldCheck, Wrench, BookOpenText, Lightbulb,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ActivityFilter as FilterType } from '../types'

const FILTERS: { id: FilterType; icon: LucideIcon }[] = [
  { id: 'all', icon: Sparkles },
  { id: 'emails', icon: Mail },
  { id: 'approvals', icon: ShieldCheck },
  { id: 'tools', icon: Wrench },
  { id: 'notebook', icon: BookOpenText },
  { id: 'nudges', icon: Lightbulb },
]

interface Props {
  active: FilterType
  onFilter: (f: FilterType) => void
}

export default function ActivityFilterBar({ active, onFilter }: Props) {
  const { t } = useTranslation('activity')

  return (
    <div className="flex gap-1 items-center overflow-x-auto scrollbar-hide -mx-1 px-1">
      {FILTERS.map(({ id, icon: Icon }) => {
        const isActive = active === id
        return (
          <button
            key={id}
            onClick={() => onFilter(isActive ? 'all' : id)}
            className={`relative flex items-center gap-2 px-4 py-2 text-xs font-medium tracking-wide uppercase whitespace-nowrap transition-all ${
              isActive
                ? 'text-gold'
                : 'text-pearl/60 hover:text-ivory/70'
            }`}
          >
            <Icon size={14} strokeWidth={isActive ? 2.5 : 2} />
            {t(`filter.${id}`)}
            {isActive && (
              <span className="absolute bottom-0 left-2 right-2 h-[2px] rounded-full bg-gold" />
            )}
          </button>
        )
      })}
    </div>
  )
}
